// /* eslint-disable eslint-comments/disable-enable-pair */

import { docodeHexResponse } from '../../../_common/common.utils';
import BankActionTypes from './bank-details.types';

const INITIAL_STATE: any = {
	addBusinessBankResponse: null,
	fetchBusinessBankResponse: null,
	fetchBusinessBankData: [],
	updateBusinessBankResponse: null,
	deleteBusinessBankResponse: null,
};

const businessBankDetailsReducer: any = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/**************  START ADD BUSINESS BANK **********************/
		case BankActionTypes.ADD_BUSINESS_BANK_SUCCESS:
			return { ...state, addBusinessBankResponse: action.payload };

		case BankActionTypes.ADD_BUSINESS_BANK_FAILURE:
			return { ...state, addBusinessBankResponse: action.payload };

		case BankActionTypes.ADD_BUSINESS_BANK_RESPONSE_CHANGED:
			return { ...state, addBusinessBankResponse: null };
		/**************  END ADD BUSINESS BANK **********************/

		/**************  START FETCH BUSINESS BANK **********************/
		case BankActionTypes.FETCH_BUSINESS_BANK_SUCCESS:
			return {
				...state,
				fetchBusinessBankResponse: action.payload,
				fetchBusinessBankData: docodeHexResponse(action.payload, 'GetBankDetailsKey'),
			};

		case BankActionTypes.FETCH_BUSINESS_BANK_FAILURE:
			return { ...state, fetchBusinessBankResponse: action.payload };

		case BankActionTypes.FETCH_BUSINESS_BANK_RESPONSE_CHANGED:
			return { ...state, fetchBusinessBankResponse: null };
		/**************  END FETCH BUSINESS BANK **********************/

		/**************  START UPDATE BUSINESS BANK **********************/
		case BankActionTypes.UPDATE_BUSINESS_BANK_SUCCESS:
			return { ...state, updateBusinessBankResponse: action.payload };

		case BankActionTypes.UPDATE_BUSINESS_BANK_FAILURE:
			return { ...state, updateBusinessBankResponse: action.payload };

		case BankActionTypes.UPDATE_BUSINESS_BANK_RESPONSE_CHANGED:
			return { ...state, updateBusinessBankResponse: null };
		/**************  END UPDATE BUSINESS BANK **********************/

		/**************  START DELETE BUSINESS BANK **********************/
		case BankActionTypes.DELETE__BUSINESS_BANK_SUCCESS:
			return { ...state, deleteBusinessBankResponse: action.payload };

		case BankActionTypes.DELETE__BUSINESS_BANK_FAILURE:
			return { ...state, deleteBusinessBankResponse: action.payload };

		case BankActionTypes.DELETE__BUSINESS_BANK_RESPONSE_CHANGED:
			return { ...state, deleteBusinessBankResponse: null };
		/**************  END DELETE BUSINESS BANK **********************/

		default:
			return state;
	}
};
export default businessBankDetailsReducer;
